/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <PageHeader {...cmsData} />)
 * and then make these props fit the final module.
 */
import React from "react"
import { PageHeader as PageHeaderModule } from "@bw/modules"

const PageHeader = props => <PageHeaderModule {...props} />

export { PageHeader }
